import { cva, type VariantProps } from "class-variance-authority";
import type { HTMLAttributes } from "react";
import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center gap-1 rounded-sm border px-2 py-0.5 text-xs font-medium",
  {
    variants: {
      tone: {
        neutral: "border-transparent bg-surface-muted text-ink-muted",
        accent: "border-transparent bg-accent-soft text-accent-strong",
        success: "border-transparent bg-accent-soft text-success",
        warning: "border-transparent bg-accent-soft text-warning",
        danger: "border-transparent bg-accent-soft text-danger",
        outline: "bg-transparent text-ink-muted border-line-strong",
      },
    },
    defaultVariants: { tone: "neutral" },
  }
);

export interface BadgeProps
  extends HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, tone, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ tone }), className)} {...props} />;
}
